module.exports = __webpack_public_path__ + "static/media/sopt30ru.9aab2c7f.pdf";